// Helper functions and utilities

export const isTouch = () =>
  matchMedia('(hover: none) and (pointer: coarse)').matches ||
  ('ontouchstart' in window) ||
  navigator.maxTouchPoints > 0;

export const showAllContent = () => {
  document.querySelectorAll('.reveal,[data-fade]').forEach(e => e.style.opacity = '1');
  document.querySelectorAll('.hero h1 .line span').forEach(e => e.style.transform = 'none');
  document.querySelectorAll('.hero-photo-wrap').forEach(e => e.style.opacity = '1');
  document.querySelectorAll('[data-count]').forEach(e => (e.textContent = e.dataset.count + (e.dataset.suffix || '')));
};
